/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import HousingProjectInformationList from 'components/housing-project-information-list';
import HousingProjectTimeline from 'components/housing-project-timeline';
import HousingProjectStatus from 'components/housing-project-status';
import HousingProjectContactCard from 'components/housing-project-contact-card';
import Heading from 'components/heading';
import ContentWrapper from 'components/content-wrapper';
import Link from 'components/link';
import Icon from 'components/icon';
import cn from 'classnames';

const baseThemes = {
  dark: 'dark',
  light: 'light'
};

const colorThemes = {
  _: '',
  green: 'green'
};

const HousingProjectInformation = ({
  title,
  location,
  informationListGroups,
  timeline,
  statusList,
  contactCard,
  baseTheme,
  colorTheme,
  headingLevel
}) => {
  return (
    <div
      className={cn('housing-project-information', {
        [`housing-project-information--${baseTheme}`]: baseTheme
      })}
    >
      <ContentWrapper>
        <div className="housing-project-information__content">
          <div className="housing-project-information__content-top">
            {title && (
              <Heading
                className="housing-project-information__title"
                level={headingLevel}
              >
                {title}
              </Heading>
            )}
            <div className="housing-project-information__link-container">
              <Icon
                className="housing-project-information__link-icon"
                name="location"
              />
              <Link
                className="housing-project-information__link"
                animation="expand"
                {...location}
              />
            </div>
          </div>
          <div className="housing-project-information__content-left">
            <div className="housing-project-information__key-information">
              {informationListGroups &&
                informationListGroups.length !== 0 &&
                informationListGroups.map((group, index) => (
                  <HousingProjectInformationList
                    key={index}
                    {...group}
                    baseTheme={baseTheme}
                  />
                ))}
            </div>
            {timeline && (
              <div className="housing-project-information__timeline">
                <HousingProjectTimeline {...timeline} baseTheme={baseTheme} />
              </div>
            )}
          </div>
          <div className="housing-project-information__content-right">
            <div className="housing-project-information__status">
              {statusList &&
                statusList.length !== 0 &&
                statusList.map(item => (
                  <HousingProjectStatus
                    key={item.title}
                    {...item}
                    baseTheme={baseTheme}
                    colorTheme={colorTheme}
                  />
                ))}
            </div>
            {contactCard && (
              <div className="housing-project-information__contactcard">
                <HousingProjectContactCard
                  {...contactCard}
                  baseTheme={baseTheme}
                />
              </div>
            )}
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};

HousingProjectInformation.propTypes = {
  title: PropTypes.string,
  location: PropTypes.exact(Link.propTypes),
  informationListGroups: PropTypes.arrayOf(
    PropTypes.exact(HousingProjectInformationList.propTypes)
  ),
  timeline: PropTypes.exact(HousingProjectTimeline.propTypes),
  statusList: PropTypes.arrayOf(
    PropTypes.exact(HousingProjectStatus.propTypes)
  ),
  contactCard: PropTypes.exact(HousingProjectContactCard.propTypes),
  baseTheme: PropTypes.oneOf(Object.values(baseThemes)),
  colorTheme: PropTypes.oneOf(Object.values(colorThemes)),
  headingLevel: PropTypes.number
};

HousingProjectInformation.propTypesMeta = {
  baseTheme: 'exclude',
  colorTheme: 'exclude',
  headingLevel: 'exclude'
};

export default HousingProjectInformation;